module.exports = __webpack_public_path__ + "img/9788997798391.d09a8b93.jpg";